// extracted by mini-css-extract-plugin
module.exports = {"navigation":"Initial_navigation__3DQQM","fishBTN":"Initial_fishBTN__20_Zu","openMainMenuBTN":"Initial_openMainMenuBTN__T-VuA","open":"Initial_open__2SBPm"};